import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-application",
  "use": "icon-application-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol viewBox=\"0 0 16 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-application\">\n<path d=\"M14.25 6.30188H9.25V1.30188H1.75V16.3019H14.25V6.30188ZM13.7425 5.05188L10.5 1.80938V5.05188H13.7425ZM1.125 0.0518799H10.5L15.5 5.05188V16.9269C15.5 17.1094 15.4415 17.2592 15.3244 17.3763C15.2073 17.4933 15.0575 17.5519 14.875 17.5519H1.125C0.9425 17.5519 0.792708 17.4933 0.675625 17.3763C0.558542 17.2592 0.5 17.1094 0.5 16.9269V0.67688C0.5 0.49438 0.558542 0.344588 0.675625 0.227505C0.792708 0.110421 0.9425 0.0518799 1.125 0.0518799ZM4.25 8.80188H11.75V10.0519H4.25V8.80188ZM4.25 5.05188H7.375V6.30188H4.25V5.05188ZM4.25 12.5519H11.75V13.8019H4.25V12.5519Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/application.svg
// module id = tvpt
// module chunks = 258